import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatRealmMemberPartedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const realmMemberParted: CaseReducer<NinchatState> = (state, action) => {
    const {
        event_cause, // eslint-disable-line @typescript-eslint/no-unused-vars
        realm_id,
        user_id,
        ...rest
    } = extractProperties<NinchatRealmMemberPartedEvent>(action.payload)

    isEmpty(rest)

    delete state.user_realms[realm_id]?.realm_members?.[user_id]
}
